import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import useIdleLogout from './useIdleLogout';
import { inactivityLogout } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, logout } = useAuth();
  const idleTimer = 60; // in Minutes

  const userLogoutDueToInactivity = async () => {
    try {
      await inactivityLogout();
    } catch (err) {
    } finally {
      logout();
      localStorage.removeItem('token');
      navigate('/login', { replace: true });
    }
  }
  useIdleLogout(
    (idleTimer * 60 * 1000),
    async () => {
      await userLogoutDueToInactivity();
    }
  );

  if (isLoading) {
    return <div></div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;